module.exports = {
  language: 'Uzbek',
  nationalityKay: 'uz-uz',
  personal: {
    purgePopupContent:
      'Kechirasiz, ilova maʼlumotlaringiz xavfsizlik siyosati tufayli oʻchirildi, agar tez orada ariza topshirishni istasangiz, biz bilan bogʻlanishingiz mumkin'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  noneSelectedText: 'Iltimos tanlang',
  multiselect: {
    deselect: "O'chirish uchun Enter tugmasini bosing",
    select: 'Tanlash uchun Enter tugmasini bosing',
    selected: 'Tanlandi'
  },
  enter: ' Kirish',
  upload_failed: 'Yuklab bo‘lmadi, qayta urinib ko‘ring',
  due_time: 'Kerakli vaqt',
  requirement: 'Talab',
  something_went_wrong_please_retry: 'Qandaydir xato yuz berdi, Iltimos qaytadan urining.',
  valid_rediret_home_page_popup_content:
    'Kirish istisnosi yuz berdi. Tizimga kirish uchun [ {country} - {center} ] bosh sahifasiga oʻtmoqchimisiz? Ha bo\'lsa, "Tasdiqlash" tugmasini bosing; agar yo\'q bo\'lsa, yana tanlash uchun "Bekor qilish" tugmasini bosing.',
  invalid_rediret_home_page_popup_content: 'Kirish istisnosi yuz berdi, davom etish uchun mamlakat va manzilni tanlang.',
  'Temporarily not available': 'Vaqtinchalik mavjud emas',
  'Coming soon': 'Tez kunlarda'
};
